// TotalInventoryExpired Mutations

export const updateTotalInventoryExpiredList = (state, payload) => {
  state.totalInventoryExpiredList = payload
}

export const fetchTotalInventoryExpiredCount = (state, payload) => {
  state.totalInventoryExpiredCount = payload
}
